export default __webpack_public_path__ + "static/media/home-header.d7045bf7.png";